import { Component, OnInit } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { PagesService } from '../services/pages.service';
import { NetworkServiceService } from '../services/network-service.service';
import { Platform } from '@ionic/angular';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import { EventsService } from '../services/events.service';
import { MenuService } from '../services/menu.service';
import { ThemeService } from '../services/theme.service';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { MessagesService } from '../services/messages.service';
import { AlertController } from '@ionic/angular';

// training services
import { TrainingService } from '../services/training.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  blogList: any;
  blogContent: string;
  blogTitle: string;
  networkImage: string;
  networkList: any;
  breakpoint: any;
  courseList: any;
  menuPages: any;
  menuItems: any;
  themeList: any;
  uid: string;
  userEmail: string;
  loading: any;
  data: any;
  error: string;
  message: any;

  eventList: any;
  attendee: string;
  events: any;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private pageService: PagesService,
    private networkService: NetworkServiceService,
    private platform: Platform,
    private eventsService: EventsService,
    private menuService: MenuService,
    private themeService: ThemeService,
    private http: HttpClient,
    public loadingController: LoadingController,
    private messageService: MessagesService,
    public alertController: AlertController,
    private trainingService: TrainingService
    ) {
      //this.data = '';
      this.error = '';

      firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          this.uid = user.uid;
          this.userEmail = user.email;
          console.log('email', this.userEmail);

          

          this.messageService.getMessage().once('value', messageSnapshot => {
            this.message = [];
            messageSnapshot.forEach(snap => {
              if (snap.val().active === 'true' && snap.val().message_type === 'urgent' ) {
                this.message.push({
                  title: snap.val().title,
                  message: snap.val().message,
                  date: snap.val().date,
                  messageType: snap.val().message_type,
                  user: snap.val().user
                });
              }
              
            });
            this.presentAlert();
            // console.log('message from component', this.message);
            
          });
        } else {
          this.router.navigateByUrl('sign-in');
        }
      });

      this.themeService.getThemeList().once('value', themeSnapshot => {
        this.themeList = [];
        themeSnapshot.forEach(snap => {
          this.themeList.push({
            companyLogo: snap.val().baseurl + snap.val().logo
          });
        });
      });

      this.networkService.getNetwork().once('value', networkSnapshot => {
        this.networkList = [];
        networkSnapshot.forEach(snap => {
          if (snap.val().state === '1') {
            this.networkList.push({
              title: snap.val().network_name,
              description: snap.val().network_description,
              bannerImage: snap.val().base_url + snap.val().banner_image,
              baseUrl: snap.val().base_url,
              oranizationName: snap.val().organization_name
            });
          }
        });
      });
    }

    async ionViewWillEnter() {
      // Present a loading controller until the data is loaded
      // await this.presentLoading();
      // Load the data
      this.prepareDataRequest()
          .pipe(
              finalize(async () => {
                // Hide the loading spinner on success or error
                // await this.loading.dismiss();
              })
          )
          .subscribe(
              data => {
                // Set the data to display in the template
                this.data = data;
                console.log(this.data);
              },
              err => {
                // Set the error information to display in the template
                this.error = `An error occurred, the data could not be retrieved: Status: ${err.status}, Message: ${err.statusText}`;
              }
          );
    }

  ngOnInit() {
  }

  async presentAlert() {
    for( let i = 0; i < this.message.length; i++) {
      const alert = await this.alertController.create({
        header: 'Message',
        subHeader: this.message[i].title,
        message: this.message[i].message,
        buttons: ['OK']
      });
      await alert.present();
    }
  }

  getMessages(): any {
    for( let i = 0; i < this.message.length; i++) {
      return this.message[i].message;
    }
  }

  logout() {
    this.authService.logoutUser();
    this.router.navigateByUrl('sign-in');
  }

  async presentLoading() {
    // Prepare a loading controller
    this.loading = await this.loadingController.create({
      message: 'Loading...'
    });
    // Present the loading controller
    await this.loading.present();
  }

  private prepareDataRequest(): Observable<object> {
    // const dataUrl = `https://sheldon.group/macouncil/getEvents.php?uid=${this.uid}`;
    // return this.http.get(dataUrl);
    this.trainingService.getEvents().once('value', snapshot => {
      this.eventList = [];
      snapshot.forEach(snap => {
        const attendee = attendeeSingle(snap.val().attendees, this.userEmail)
        if (attendee === this.userEmail) {
          this.eventList.push({
            title: snap.val().title,
            alias: snap.val().alias
          });
        }
      });
    });

    function attendeeSingle(attendee, email) {
      const attendeeList = attendee.split(',');
      for (let i = 0; i < attendeeList.length; i++) {
        if (attendeeList[i] === email) {
          return attendeeList[i];
          break;
        }
      }
    }

    return this.eventList;

  }

  goToEventPage(alias) {
    const eventPage = {
      alias: alias
    };

    const navigationExtras: NavigationExtras = {
      state: {
        event: eventPage
      }
    };
    this.router.navigate(['event-page'], navigationExtras);
  }
}
